<template>
  <div class="checkRepeat">
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center
    >
      <div class="result">
        <p>该主数据可能已经存在</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDetail">点击查看详情</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // import API from '@/api/masterData/cooperation';
  export default {
    name: 'checkRepeat',
    props: ['productChName', 'id'],
    data() {
      return {
        dialogVisible: false,
      };
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      //查看详情
      handleDetail() {
        this.dialogVisible = false;
        let path = {
          path: '/masterData/goodsDetail',
          name: 'goodsDetail',
          meta: {
            keepAlive: false,
            title: this.$t('goods.titile.goodsDetail'),
          },
          query: {
            propsGoodsId: this.id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .checkRepeat .result p {
    margin: 5px 0;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .checkRepeat .dialog-footer {
    text-align: center;
  }
</style>
